import React from 'react'

interface TableProps {
  children?: React.ReactNode
  className?: string
}

export function Table({ children, className = '' }: TableProps) {
  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className="min-w-full divide-y divide-gray-200">
        {children}
      </table>
    </div>
  )
}

export function TableHeader({ children, className = '' }: TableProps) {
  return (
    <thead className={`bg-gray-50 ${className}`}>
      {children}
    </thead>
  )
}

export function TableBody({ children, className = '' }: TableProps) {
  return (
    <tbody className={`bg-white divide-y divide-gray-200 ${className}`}>
      {children}
    </tbody>
  )
}

export function TableRow({ children, className = '', onClick }: TableProps & { onClick?: () => void }) {
  return (
    <tr 
      className={`${onClick ? 'cursor-pointer hover:bg-gray-50' : ''} ${className}`}
      onClick={onClick}
    >
      {children}
    </tr>
  )
}

export function TableHead({ children, className = '', ...rest }: TableProps & React.ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${className}`} {...rest}>
      {children}
    </th>
  )
}

export function TableCell({ children, className = '', ...rest }: TableProps & React.TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td className={`px-6 text-start py-4 whitespace-nowrap text-sm text-gray-900 ${className}`} {...rest}>
      {children}
    </td>
  )
} 